export async function isPdfFile(file) {
  if (!file || typeof file.slice !== 'function') return false
  const header = new Uint8Array(await file.slice(0, 1024).arrayBuffer())
  return String.fromCharCode(...header).includes('%PDF-')
}

export async function normalizePdfFile(file) {
  if (!await isPdfFile(file)) {
    throw new Error('Die Datei enthält keine PDF. Bitte die Original-Abrechnung als PDF teilen oder auswählen, nicht deren Bildvorschau.')
  }
  const name = String(file.name || 'Abrechnung').trim()
  return new File([file], /\.pdf$/i.test(name) ? name : `${name}.pdf`, {
    type: 'application/pdf', lastModified: file.lastModified || Date.now()
  })
}
